import { Box, Typography, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import MenuSection from "../components/MenuSection";
import { useNavigate } from "react-router-dom";
import { imprimirComprobante } from "../helpers/comprobanteUtils";
import actualizarVentaQR from "../api/actualizarVentaQR";
import { useTieneDespachos } from "../helpers/despachoUtils";

const adaptarFacturaFinalParaImpresion = facturaFinal => {
  try {
    const respuesta = facturaFinal.respuestas[0];
    const detalles = respuesta.detallesMovimiento;

    return {
      articulos: detalles.detallesArticulos.map(art => ({
        descripcion: art.descripcion,
        cantidadArticulo: art.cantidad,
        importe: art.precio * art.cantidad,
        precioUnitario: art.precio,
      })),
      total: detalles.total,
    };
  } catch (error) {
    console.error(
      "[GraciasPorComprarPage] Error adaptando facturaFinal:",
      error,
    );
    return null;
  }
};

export const GraciasPorComprarPage = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const facturaInfo = JSON.parse(localStorage.getItem("facturaInfo"));
  const pagoConQR = localStorage.getItem("pagoConQR");
  const tieneDespachos = useTieneDespachos();

  useEffect(() => {
    const procesarImpresion = async () => {
      try {
        if (pagoConQR === "true") {
          console.log("Pago con QR detectado - llamando actualizarVentaQR");

          const facturaFinal =
            await actualizarVentaQR.actualizarVenta(tieneDespachos);
          console.log("Respuesta de actualizarVentaQR:", facturaFinal);

          localStorage.setItem("facturaFinal", JSON.stringify(facturaFinal));

          if (facturaFinal) {
            console.log(
              "[GraciasPorComprarPage] Adaptando facturaFinal para impresión",
            );
            const datosParaImprimir =
              adaptarFacturaFinalParaImpresion(facturaFinal);

            if (datosParaImprimir) {
              imprimirComprobante(datosParaImprimir);
            } else {
              if (facturaInfo) imprimirComprobante(facturaInfo);
            }
          } else if (facturaInfo) {
            imprimirComprobante(facturaInfo);
          }
        } else {
          console.log("Pago normal - imprimiendo con facturaInfo");
          if (facturaInfo) imprimirComprobante(facturaInfo);
        }
      } catch (error) {
        console.error("Error al procesar actualizarVentaQR:", error);
        console.log("Fallback - imprimiendo con facturaInfo original");
        if (facturaInfo) imprimirComprobante(facturaInfo);
      }
    };

    procesarImpresion();

    setTimeout(() => {
      navigate("/tiendakioskpage", {
        state: { vieneDeFinalizar: true, limpiarProductos: true },
      });
    }, 6000);
  }, [pagoConQR, tieneDespachos]);

  return (
    <>
      <MenuSection />
      <Box
        sx={{
          backgroundColor: theme.bandera.colorSecundario,
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <Typography variant="h3" color="white" textAlign="center">
          ¡Gracias por su compra!
        </Typography>
      </Box>
    </>
  );
};
